import { useLocation } from "react-router-dom";
import { useClientCoachAccess } from "../hooks/useClientCoachAccess.js";
import { ListSectionSkeleton } from "./loading/SkeletonBlocks.jsx";
import ClientAccessEmptyState from "./ClientAccessEmptyState.jsx";
import ClientLayout from "./ClientLayout.jsx";
import { billingErrorCopy, toUserFacingBillingError } from "../lib/userFacingErrors.js";

const BYPASS_PATHS = new Set(["/billing-settings", "/settings"]);

/**
 * Gates client content until the client has an active coach plan.
 * Billing and settings remain accessible.
 */
export default function ClientAccessGate({ children }) {
  const { pathname } = useLocation();
  const { access, accessGranted, hasCoach, isLoading, error } = useClientCoachAccess();

  if (BYPASS_PATHS.has(pathname)) {
    return children;
  }

  if (isLoading && access == null) {
    return (
      <ClientLayout>
        <ListSectionSkeleton rows={3} />
      </ClientLayout>
    );
  }

  if (!hasCoach) {
    return (
      <ClientAccessEmptyState
        title="You haven't connected with a coach yet"
        description="Ask your coach to add you with this email address. Once they do, you can subscribe to their plan and unlock programs."
        showAction={false}
      />
    );
  }

  if (!accessGranted) {
    return (
      <ClientAccessEmptyState
        description={
          error
            ? toUserFacingBillingError(error, {
                fallback: billingErrorCopy.verifyClientPlan,
              })
            : undefined
        }
      />
    );
  }

  return children;
}
